import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { ModuleAppTitle } from '~/features/appearance'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as tvModel from './model'

export function Title(): JSX.Element {
  return (
    <ModuleAppTitle identifier={STATIC_IDENTIFIERS.TV} fallbackKey='live' />
  )
}

const skin = era.skin('routes/tv/root')

TVPage.displayName = 'TVPage'
export function TVPage(): JSX.Element {
  const [isContentLoading, isEmptyPage] = useUnit([
    tvModel.$contentLoading,
    tvModel.$isTvEmptyPage,
  ])

  // the empty state centres itself with `flexGrow`, which needs a flex parent
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={isEmptyPage ? 'flex-column' : ''}>
        <Skeleton pageType='main' isLoading={isContentLoading}>
          <ui.RenderSkin name='bannersTypeTv' />
          <ui.RenderSkin name='featuredCarouselTypeTv' />
          <ui.RenderSkin name='bundlesTv' />
          <ui.RenderSkin name='tvCategories' />
          <ui.RenderSkin name='infiniteTvCategory' />
          <ui.RenderSkin name='tvEmptyPage' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
